// extracted by mini-css-extract-plugin
export var productImage = "_r3-1";
export var viewLink = "_r3-2";
export var wishlistItem = "_r3-0";